/**
 * Action creators for tutorials - keeps track of whether the user has
 * completed tutorials, whether they are active and any tutorial-specific state
 */

export const SET_TUTORIALS_COMPLETED = 'SET_TUTORIALS_COMPLETED';
export const RESET_TUTORIALS = 'RESET_TUTORIALS';
export const DISABLE_TUTORIALS = 'DISABLE_TUTORIALS';

/**
 * Mark one or more tutorials as being completed
 * @param tutorialIds an array of tutorial ids
 * @param notifyServer if true, will update the user's tutorial completion state
 * on the server. We do not want to do this if this action is setting the
 * initial tutorial state from the server
 * @returns {{type: string, tutorialIds: *}}
 */
export function setTutorialsCompleted(tutorialIds, notifyServer = true) {
    return { type: SET_TUTORIALS_COMPLETED, tutorialIds, notifyServer };
}

/**
 * Reset the state of tutorials - required when logging into a new type of
 * session
 * @returns {{type: *}}
 */
export function resetTutorials() {
    return { type: RESET_TUTORIALS };
}
